export default "__VITE_ASSET__CZHzG5hN__"